import { initReactI18next } from 'react-i18next';

import i18n from 'i18next';

import enAddressModal from './en/addressConfirmationModal.json';
import enHomepage from './en/homepage.json';
import enManualEntry from './en/manualAddressEntry.json';
import esAddressModal from './es/addressConfirmationModal.json';
import esHomepage from './es/homepage.json';
import esManualEntry from './es/manualAddressEntry.json';

i18n.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  debug: false,
  resources: {
    en: {
      addressConfirmationModal: enAddressModal,
      manualAddressEntry: enManualEntry,
      homepage: enHomepage,
    },
    es: {
      addressConfirmationModal: esAddressModal,
      manualAddressEntry: esManualEntry,
      homepage: esHomepage,
    },
  },
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
